import { Feature } from '@tencent/workbench';
import BaseTitleBarFeature from '@framework/workbench/common/feature/base-titlebar-feature';
import { showRenameDialog } from '@src/js/common/ark-extensions/dc-components/rename-dialog';

@Feature()
export class RenameFeature extends BaseTitleBarFeature {
    public handleClick() {
        showRenameDialog();
    }
}
